import CollapsibleNavSection from './CollapsibleNavSection'
import EmptyStateBlock from './EmptyStateBlock'

export default function HomeVoiceNavRail() {
  return (
    <CollapsibleNavSection title="Recordings" defaultExpanded>
      <EmptyStateBlock
        title="No recordings yet"
        description="Start a recording to see your history here"
        variant="apps"
      />
    </CollapsibleNavSection>
  )
}
